import { API_HOST_ADYEN } from '@constants/api';
import { AdyenIntegration, PaymentProviderIntegration } from '../integrations';

export class PaymentProviderFactory {
  private static paymentProviderIntegration: PaymentProviderIntegration | null = null;

  public getPaymentProvider(): PaymentProviderIntegration {
    if (!PaymentProviderFactory.paymentProviderIntegration) {

      PaymentProviderFactory.paymentProviderIntegration = new AdyenIntegration({
        apiHostUrl: API_HOST_ADYEN
      });
    }

    return PaymentProviderFactory.paymentProviderIntegration;
  }
}
